import type { FC } from "react";

import styled from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";

import { InfoTooltip } from "app/components/React/Tooltip/InfoTooltip/InfoTooltip";
import { translate } from "app/filters/i18nFilter";
import { CHART_OPTIONS_META_DATA } from "app/pages/industry-analysis/players/table/bubble-chart/const";
import type { ETypes } from "app/pages/industry-analysis/players/table/bubble-chart/types";
import { devicesTypes } from "app/UtilitiesAndConstants/Constants/DevicesTypes";

const { carbon } = colorsPalettes;

const Text = styled.span`
    ${setFontVariant("caption", carbon[400])};
`;

const Container = styled.div`
    display: flex;
    gap: 8px;
`;

const YAxisContainer = styled(Container)`
    height: 370px;
    flex-direction: column;
    justify-content: center;
`;

const YAxisContent = styled(Text)`
    writing-mode: vertical-lr;
    text-orientation: sideways;
    transform: rotate(180deg);
`;

const YAxisTooltipContainer = styled.div`
    transform: rotate(270deg);
`;

const XAxisContainer = styled(Container)`
    justify-content: center;
    margin-left: 60px;
    width: calc(100% - 60px);
`;

const XAxisTooltipContainer = styled.div`
    margin-top: 1px;
`;

interface IAxisText {
    isCustomIndustry?: boolean;
    type: ETypes;
}

export const YAxisText: FC<IAxisText> = (props) => {
    const { type } = props;
    const { titleKey, titleTooltipKey } = CHART_OPTIONS_META_DATA[type].yAxis;
    return (
        <YAxisContainer>
            <InfoTooltip
                infoText={translate(titleTooltipKey)}
                infoIconContainer={YAxisTooltipContainer}
            />
            <YAxisContent>{translate(titleKey)}</YAxisContent>
        </YAxisContainer>
    );
};

export const XAxisText: FC<IAxisText> = (props) => {
    const { type } = props;
    const { titleKey, titleTooltipKey } = CHART_OPTIONS_META_DATA[type].xAxis;
    return (
        <XAxisContainer>
            <Text>{translate(titleKey)}</Text>
            <InfoTooltip
                infoText={translate(titleTooltipKey)}
                infoIconContainer={XAxisTooltipContainer}
            />
        </XAxisContainer>
    );
};
